module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/twofactor-device-5ca21890582c7163e4e747c2fa3f7b36.svg";